import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaRegEye } from 'react-icons/fa';
import { FaArrowDown } from 'react-icons/fa';
import { useManutencaoFiscal } from '../../../ManutencaoFiscalContext';
import { Row } from 'react-bootstrap';
import { ContainerGrid, ContainerAcoes, ContainerModal } from '../styles';
import { format, parseISO } from 'date-fns';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { cartaProps } from '~/pages/ManutencaoFiscal/protocols/CartaCorreacao';

const MySwal = withReactContent(Swal);
export const ModalHistoryCCe: React.FC = () => {
  const {
    setValueCarta,
    clearErrorsCarta,
    rowsHistory,
    openHistoryCarta,
    handleOpenHistoryCarta,
  } = useManutencaoFiscal();

  const columns: GridColumns = [
    {
      field: 'num_seq',
      headerName: 'Número',
      align: 'left',
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (row: any) => {
        return <span>{row.value}</span>;
      },
    },
    {
      field: 'dta_cadastro',
      headerName: 'Data',
      sortable: false,
      disableColumnMenu: true,
      width: 180,
      renderCell: (row: any) => {
        return <span>{format(parseISO(row.value), 'dd/MM/yyyy HH:mm')}</span>;
      },
    },
    {
      field: 'des_titulo',
      headerName: 'Título',
      align: 'left',
      sortable: false,
      disableColumnMenu: true,
      width: 300,
      renderCell: (row: any) => {
        return <span>{row.value}</span>;
      },
    },
    {
      field: '',
      headerName: 'Ações',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      width: 120,
      headerClassName: 'hideRightSeparator',
      renderCell: (row: any) => {
        return (
          <ContainerAcoes>
            <button type="button" onClick={() => openDesCCe(row.row.des_cce)}>
              <FaRegEye color="#0166fe" />
            </button>
            <button
              type="button"
              onClick={() => setFieldsCarta(row.row.num_seq)}
            >
              <FaArrowDown color="#2bff00" />
            </button>
          </ContainerAcoes>
        );
      },
    },
  ];

  const openDesCCe = (des_cce: string) => {
    MySwal.fire({
      text: `${des_cce}`,
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        const popup = Swal.getPopup();
        if (popup) {
          popup.focus();
          const keyHandler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
              Swal.close();
            }
            if (e.key === 'Enter') {
              Swal.clickConfirm();
            }
          };
          window.addEventListener('keydown', keyHandler);
          Swal.getPopup()?.addEventListener('swal:close', () => {
            window.removeEventListener('keydown', keyHandler);
          });
        }
      },
    });
  };

  const setFieldsCarta = (num_seq: number) => {
    const newValues: cartaProps[] = rowsHistory.filter(
      (item) => item.num_seq === num_seq,
    );
    setValueCarta('des_titulo', newValues[0].des_titulo);
    setValueCarta('des_cce', newValues[0].des_cce);
    clearErrorsCarta();
    handleOpenHistoryCarta(false);
  };

  return (
    <ContainerModal>
      <Modal
        show={openHistoryCarta}
        animation
        onHide={() => {
          handleOpenHistoryCarta(false);
        }}
        centered
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Histórico CCe</Modal.Title>
          <button
            type="button"
            onClick={() => handleOpenHistoryCarta(false)}
            style={{
              right: '10px',
              top: '10px',
              fontSize: '20px',
              cursor: 'pointer',
              outline: 'none',
              background: 'none',
              border: 'none',
            }}
          >
            x
          </button>
        </Modal.Header>
        <Modal.Body style={{ marginBottom: '20px' }}>
          <Row>
            <ContainerGrid style={{ height: '280px' }}>
              <DataGrid
                className="grid"
                rowsPerPageOptions={[3]}
                pageSize={3}
                rows={rowsHistory}
                columns={columns}
                rowHeight={40}
                getRowId={(row) => row.num_seq}
                disableColumnFilter
                disableColumnSelector
                disableColumnMenu
                disableSelectionOnClick
                localeText={{
                  noRowsLabel: 'Nenhum registro encontrado....',
                  columnMenuLabel: 'Menu',
                  columnMenuFilter: 'Filtrar',
                  columnMenuHideColumn: 'Esconder',
                  columnMenuUnsort: 'Não ordenar',
                  columnMenuSortAsc: 'Ordernar ASC',
                  columnMenuSortDesc: 'Ordernar DESC',
                  columnMenuShowColumns: 'Mostrar columnas',
                }}
              />
            </ContainerGrid>
          </Row>
        </Modal.Body>
      </Modal>
    </ContainerModal>
  );
};
